@if (activeEnvironmentBanner; as banner) {
<div
  class="mile-env-banner w-100 text-center {{ banner.cssClass }}"
  role="status"
  aria-live="polite"
>
  {{ banner.text }}@if (banner.emphasizedPart) {
  <span class="mile-env-banner__pulse">{{ banner.emphasizedPart }}</span>
  }
</div>
}

<app-navbar></app-navbar>

<div class="row w-100">
  <div class="col">
    <!-- Navbar com botão para abrir/fechar menu lateral -->
    <nav class="px-2 pt-2 d-md-none">
      <button class="btn btn-outline-primary " (click)="toggleSidebar()">
        <i class="fas fa-bars"></i>
      </button>
    </nav>
  </div>
  <div class="">
    <!-- Menu lateral (mobile) -->
    <div class="sidebar-mobile d-md-none">
      <div class="overlay" (click)="toggleSidebar()"></div>

      @if(isSidebarOpen){
      <div class="menu p-3">
        <app-sidebar></app-sidebar>
      </div>
      }

    </div>

    <div class="d-flex flex-grow-1">
      <!-- Menu lateral (desktop) -->
      <div class="sidebar d-none d-md-flex flex-column">

        <div class="sidebar-desktop-toolbar px-1 py-2 d-flex align-items-center gap-1 border-bottom">
          <button type="button" class="btn btn-sm btn-outline-secondary sidebar-toolbar-btn"
            (click)="toggleDesktopSidebar()"
            [attr.aria-expanded]="!isSidebarCollapsed"
            [attr.title]="isSidebarCollapsed ? 'Expandir menu' : 'Recolher menu'">
            <i class="fas" [ngClass]="isSidebarCollapsed ? 'fa-angle-double-right' : 'fa-angle-double-left'"></i>
          </button>
          @if (!isSidebarCollapsed) {
          <button type="button" class="btn btn-sm btn-outline-secondary sidebar-toolbar-btn"
            (click)="togglePin()"
            [class.active]="isSidebarPinned"
            [attr.aria-pressed]="isSidebarPinned"
            [attr.title]="isSidebarPinned ? 'Desafixar menu (voltar a recolher ao sair com o mouse)' : 'Fixar menu aberto'">
            <i class="fas fa-thumbtack"></i>
          </button>
          }
        </div>

        <div class="sidebar-container" [ngClass]="{ 'open': !isSidebarCollapsed }" (mouseenter)="expandSidebar()"
          (mouseleave)="collapseSidebar()">
          <app-sidebar [collapsed]="isSidebarCollapsed"></app-sidebar>
        </div>
      </div>
      <main class="content flex-grow-1 color-container"
        [ngClass]="{ 'expanded': !isSidebarCollapsed, 'ms-0':isSidebarCollapsed }">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</div>
